var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._l((_vm.zhongwaiList),function(item,i){return _c('span',{key:i,staticClass:"specialty_name"},[_vm._v(" "+_vm._s(item.level)+" ")])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"name"},[_vm._v("中外合作办学")])])
}]

export { render, staticRenderFns }